import { isCalendlyMeeting } from 'shared/utils'

/**
 * Shared utilities for meeting detail components.
 * These are moved from features/meetings/utils to avoid cross-feature dependencies.
 */

export const isPendingEvent = (event) => event?.pendingType === 'AdhocEventType' || event?.pendingType === 'Share'

/**
 * Analytics payload for scheduling in real time flow
 */
export const getScheduleInRealTimeAnalyticsPayload = () => ({
  name: 'Flow Started',
  properties: {
    flow_name: 'schedule_in_real_time',
    flow_location: 'meetings_page_right_rail',
  }
})

/**
 * Analytics payload for scheduling a follow-up meeting
 */
export const getScheduleFollowUpAnalyticsPayload = (event) => ({
  name: 'Meeting Interaction',
  properties: {
    action: 'schedule_follow_up',
    location: 'meetings_page_right_rail',
    event_uuid: event.uuid,
    mi_event_uuid: event.meetingIntelligence?.uuid,
    is_calendly_meeting: isCalendlyMeeting(event),
  }
})

/**
 * Analytics payload for reporting an event
 */
export const getReportEventAnalyticsPayload = (event) => ({
  name: 'Meeting Interaction',
  properties: {
    action: 'report_meeting',
    location: 'meetings_page_right_rail',
    event_uuid: event.uuid,
    mi_event_uuid: event.meetingIntelligence?.uuid,
    is_calendly_meeting: isCalendlyMeeting(event),
  }
})

/**
 * Analytics payload for viewing more invitees
 */
export const getViewMoreInviteesAnalyticsPayload = (event) => ({
  name: 'Meeting Interaction',
  properties: {
    action: 'view_more_invitees',
    location: 'meetings_page_right_rail',
    event_uuid: event?.uuid,
    mi_event_uuid: event?.meetingIntelligence?.uuid,
    is_calendly_meeting: isCalendlyMeeting(event),
  }
})

/**
 * Transforms location kind from snake_case to Title Case
 * Example: "GOOGLE_MEET" -> "Google Meet"
 */
export const transformLocationKind = (locationKind) => locationKind
  .split('_')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ')
